import React, { useState } from 'react';
import { Container, Typography, Box, CircularProgress, TextField, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import toast from 'react-hot-toast';
import { useQueryClient } from 'react-query';

import { getUserDetails } from '../../utils';
import { useQueryGetPairedUsersAdmin } from '../../hooks/react-query/pairing';
import { TableView } from '../../components/table';

export default function PrincipalPairings() {
  const queryClient = useQueryClient();
  const userDetails = getUserDetails();
  const userToken = userDetails?.token;
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [searchedValue, setSearchedValue] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  // Fetch pairs - automatically filtered by principal's assigned schools on backend
  const { data: pairedUsersData, isFetching: isLoadingPairs } = useQueryGetPairedUsersAdmin(
    userToken,
    navigate,
    toast,
    1, // Always get first page
    1000, // Get a large number to show all pairs
    searchQuery
  );

  // Server-side search function
  const searchFromRecord = () => {
    setSearchQuery(searchedValue);
  };

  const clearSearch = () => {
    setSearchedValue('');
    setSearchQuery('');
  };

  return (
    <Box>
      <Helmet>
        <title>Edifying Teachers | Pairing Management</title>
      </Helmet>

      <Container maxWidth="xl" sx={{ padding: '0 !important' }}>
        <Box>
          <Typography variant="h3" sx={{ mb: '5px', color: 'text.titles' }}>
            Pairing Management
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            mt: '23.63px',
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', md: 'row' },
            rowGap: '20px',
          }}
        >
          <Box sx={{
            display: 'flex',
            columnGap: '17px',
            flexDirection: { xs: 'column', md: 'row' },
            rowGap: '20px',
            justifyContent: 'flex-start',
            width: '100%'
          }}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <TextField
                placeholder="Search Pairs by Name"
                className="filters"
                value={searchedValue}
                sx={{ minWidth: '233px', maxWidth: { xs: '100%', md: '233px' } }}
                onChange={(e) => setSearchedValue(e.target.value.toLowerCase())}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    searchFromRecord();
                  }
                }}
              />

              <Button
                variant="contained"
                color="main"
                sx={{ height: 'fit-content', my: 'auto', width: 'max-content' }}
                onClick={() => searchFromRecord()}
              >
                Search
              </Button>

              {(searchQuery || searchedValue) && (
                <Button
                  variant="outlined"
                  color="secondary"
                  sx={{ height: 'fit-content', my: 'auto', width: 'max-content' }}
                  onClick={clearSearch}
                >
                  Clear
                </Button>
              )}
            </Box>
          </Box>
        </Box>

        {isLoadingPairs && (
          <Box sx={{ textAlign: 'center', mt: '30px' }}>
            <CircularProgress />
          </Box>
        )}

        {!isLoadingPairs && (
          <TableView
            tableData={pairedUsersData?.data || []}
            setOpen={setOpen}
            userRole={userDetails?.role.toLowerCase()}
            searchedValue={searchedValue}
            isEndingTraining={false}
            isEndingPairing={false}
            setTrainingEndingPayload={() => {}}
            setPairingEndingPayload={() => {}}
            pairedDisplay
            isViewOnly
          />
        )}
      </Container>
    </Box>
  );
}

